export default __webpack_public_path__ + "static/media/__apple_icon_text.aa54c1c2.svg";